import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { IProjectActivity, IProjectActivityAddQuestionAnswer } from '../../projectDetailsActivities.models';

export const AddQuestionAnswerActivity = ({ values }: IProjectActivity<IProjectActivityAddQuestionAnswer>): ReactElement => {
  const { t } = useTranslator();
  return (
    <span>
      {t('activity_description_common.addAnswer')}
      <b>{values.answer}</b> {t('activity_description_common.to')} {t('activity_description_common.question')} <b>{values.question}</b>.
    </span>
  );
};
